// extracted by mini-css-extract-plugin
export default {"pendingContainer":"PendingApplication_pendingContainer","link":"PendingApplication_link"};